<div class="component-card m-0">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'Member Companies'|translate}} </h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon"
                    (click)="searchMemberCompanies(searchMemberCompanyModel)"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" [(ngModel)]="searchMemberCompanyModel.name"
                    placeholder="Search...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
            <p-dropdown class="src_dropdown" [options]="src_drop_opt" [(ngModel)]="selected_drop_opt" optionLabel="name"
                optionValue="id"></p-dropdown>
            <div class="p-inputgroup div_search_field ps-3 w-50">
                <button type="button" class="search_btn_icon"
                    (click)="searchMemberCompanies(searchMemberCompanyModel)"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" [(ngModel)]="searchMemberCompanyModel.city"
                    placeholder="Location...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
        </div>
    </div>
</div>

<p-tabView id="userTabs" class="payment-tabs" (onChange)="changeTabView($event)">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'All'|translate}} <span class="color_mono_txt"> ( {{totalRecords}} )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="membersCopmanyTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'ACTIVE'|translate}} <span class="color_mono_txt">( {{activeCompanies}}
                    )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="membersCopmanyTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'SUSPENDED'|translate}}<span class="color_mono_txt">(
                    {{suspendedCompanies}} )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="membersCopmanyTemplate"></ng-container>
        </div>
    </p-tabPanel>
</p-tabView>


<ng-template #membersCopmanyTemplate>
    <p-progressSpinner *ngIf="spinner" id="full_spinner"></p-progressSpinner>
    <div style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden; " infiniteScroll
        [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMoreMemberCompanies()"
        [scrollWindow]="false">
        <div *ngFor="let company of companyList" class="component-card">
            <div class="component-list-card">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex flex-row me-3" style="align-items: self-end;">
                        <img class="payment_picture_list" [src]="company.ImagePath ? company.ImagePath : imagePath"
                            alt="profile-picture">
                        <div class="company_info lh-sm">
                            <label class="user_name"><i *ngIf="!company.active" class="pi pi-ban user_susp"></i>{{
                                company.companyName }} </label>
                            <label class="user_location">{{ company.city }}, {{ company.countryCode }}</label>
                            <label class="lbl_12px">{{company.generalManagerName }} </label>
                        </div>
                    </div>
                    <div class="div_group_payment">

                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'MEMBERSHIP' | translate }}</label>
                            <label class="lbl_list">{{ company.MembershipName }}<span>
                                    {{company.MembershipPrice}}</span></label>
                            <label class="lbl_list_price">{{ company.TotalPrice }}</label>
                        </div>
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'ACTIVITY' | translate }}</label>
                            <label class="lbl_color_list border_none">{{ 'Venues'|translate }}<span
                                    class="spam_white float-end">{{company.numberOfVenues}}</span></label>
                            <label class="lbl_color_list border_none">{{ 'Events'|translate }}<span
                                    class="spam_white float-end">{{company.numberOfEvents}}</span></label>
                        </div>
                    </div>
                    <div class="ms-2" style="max-width: 140px;">
                        <button class=" btn_without_color btn_border_color w-100 mb-2"
                            (click)="detailsCompany(company.id)">{{ 'Details' | translate}}</button>
                        <button *ngIf="company.active" class="btn_in_color  w-100"
                            (click)="suspendedCompany(company.id)">{{ 'Suspended'
                            |translate}}</button>
                        <button *ngIf="!company.active" class="btn_in_color  w-100"
                            (click)="unsuspendedCompany(company.id)">{{ 'Unsuspended'
                            |translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>